<div class="login-factory-form">
  <credential-login
    (emailChange)="email = $event"
    (afterLogin)="afterLogin.emit()"
  ></credential-login>
  <div class="login-factory-actions">
    <a routerLink="/forgot-password" class="login-link">
      {{ 'account.login.forgotPassword' | transloco }}
    </a>&nbsp;
    @if (registrationEnabled) {
      <a routerLink="/register" class="login-link">
        {{ 'account.login.createAccount' | transloco }}
      </a>
    }
    @if (!registrationEnabled && hasUsableRegistrationKeys) {
      <a
        routerLink="/register"
        class="login-link"
        >
        {{ 'account.login.haveRegistrationCode' | transloco }}
      </a>
    }
  </div>
</div>
